import { isSP } from "../../../common/functions/isSP";

export default class Archive {
    constructor() {
        this.init();
    }

    init() {
        this.categorynav();
        this.setDepth();
        this.setBackPage();
    }

    setBackPage() {
        if (!document.querySelector(".works_archive")) {
            return;
        }

        //セッションストレージに戻り先を保存
        const nowpage = window.location.href;
        window.sessionStorage.setItem("yet_works_backURL", nowpage);
    }

    categorynav() {
        const trigger = document.querySelector(".js-categorytrigger");

        if (!trigger) {
            return;
        }

        trigger.addEventListener("click", () => {
            if (!isSP()) {
                return;
            }
            const inner = trigger.querySelector(".works__catlist");
            trigger.classList.toggle("-open");

            if (trigger.classList.contains("-open")) {
                trigger.style.height = `${inner.offsetHeight}px`;
            } else {
                trigger.style.height = `32px`;
            }
        });
    }

    setDepth() {
        const item = document.querySelector(".works__list__item");

        if (!item) {
            return;
        }

        const setDepthVar = () => {
            document.documentElement.style.setProperty("--cubeDepth", `${item.offsetWidth / 2}px`);
        };

        window.addEventListener("resize", setDepthVar);
        setDepthVar();
    }
}
